import { render, staticRenderFns } from "./ContentPlaceholdersHeading.vue?vue&type=template&id=f15ce194"
import script from "./ContentPlaceholdersHeading.vue?vue&type=script&lang=js"
export * from "./ContentPlaceholdersHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports